import React, {FC} from 'react';
import { Product } from '../../entity/product';
import { ProductCard } from '../../components/ProductCard';
/** temporary usage of the api mock */
import { mockProductList as productList } from "../../entity/product";

export type CategoryProps = {
  /**
   * the category id if set, otherwise null
   */
  id: string | null
  products: Product[]
}

export const Category:FC<CategoryProps> = ({id, products}) => {
  /**
   * ToDo: get the category from api by id
   */
  return (
    <div className="product-grid">
      {products.map((product, index) => (
        <ProductCard
          key={product.pzn || index}
          hit={{
            objectID: String(product.pzn),
            name: product.title,
            image_url: product.src || '',
            pzn: Number(product.pzn),
            price_no_format: parseFloat(product.price) || 0,
            product_url: product.link || '',
            rating: 0,
            rating_count: '0',
            products_id: String(product.pzn),
            eyecatcher: '',
            amount_unit: '',
            avp_no_format: parseFloat(product.price) || 0,
            avp_formatted: product.price || '',
            price_formatted: product.price || '',
            status_text: '',
            status_number: 0,
            status_information: '',
            herbal: 0,
            homeopathic: 0,
            prescription_required: 0,
            presentation_form: '',
            base_price: '',
            alternative_package_sizes: [],
            highlights: '',
            __position: index + 1,
            __queryID: undefined,
            subscription_status: 0,
            subscription_savings: 0,
            isPromoted: false,
            adSpiritClickUrl: undefined,
            products_indicator: undefined
          }}
        />
      ))}
    </div>
  );
}
